/**
 * Where saved reports live in the URL — M10 / S10-05.
 *
 * Under the Project, like every other Project capability. **No top-level
 * Reports area**, because a saved report belongs to the job it documents.
 */

export function savedReportsPath(projectId: string): string {
  return `/projects/${projectId}/reports`;
}

export function savedReportPath(projectId: string, reportId: string): string {
  return `/projects/${projectId}/reports/${reportId}`;
}
